<script>
  import dayjs from 'dayjs'
  import localizedFormat from 'dayjs/plugin/localizedFormat'
  import Card from '../../../components/card.svelte'
  import DataTable from '../../../components/data_table.svelte'
  import StateChip from '../../../components/badges/state_chip.svelte'
  import { FRIENDSHIP_STATUS } from '../../../components/badges/chip_maps.js'

  dayjs.extend(localizedFormat)

  // { records, total_count, shown } — the server sends the newest rows plus the real total.
  let { friendships = { records: [], total_count: 0 } } = $props()

</script>

<Card title="Friendships">
  {#snippet actions()}
    <span class="badge badge-ghost">{friendships.total_count}</span>
  {/snippet}

  <DataTable items={friendships.records} emptyMessage="No friendships.">
    {#snippet header()}
      <tr>
        <th>User</th>
        <th>Direction</th>
        <th>Status</th>
        <th>Date</th>
      </tr>
    {/snippet}
    {#snippet row(friendship)}
      <tr>
        <td>
          <a href={friendship.other_user.url} class="link link-hover">
            {friendship.other_user.name || friendship.other_user.id}
          </a>
        </td>
        <td class="capitalize">{friendship.direction}</td>
        <td><StateChip label={friendship.status_label} tone={FRIENDSHIP_STATUS[friendship.status] || 'ghost'} /></td>
        <td>{dayjs(friendship.created_at).format('ll')}</td>
      </tr>
    {/snippet}
  </DataTable>
  {#if friendships.total_count > friendships.records.length}
    <p class="text-xs text-base-content/60 mt-2">Showing latest {friendships.records.length} of {friendships.total_count}.</p>
  {/if}
</Card>
